
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ScaTargetsTableLoading',
  props: {
    isWidget: {
      type: Boolean,
      default: false
    },
    rowCount: {
      type: Number,
      default: 20
    }
  }
})
